import request from '@/utils/request'

export function getLocationByAmap(latitude,longitude) {
  return request({
    url: "cus/getLocation/"+latitude+"/"+longitude,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/location.js